import PropTypes from 'prop-types';

const companyPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

const projectPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  company: companyPropType.isRequired,
});

const testerPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  project: projectPropType.isRequired,
});

const testSessionPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  tester: testerPropType.isRequired,
});

const testSessionNotePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  testSession: testSessionPropType.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  note: PropTypes.string.isRequired,
});

export const videosDataPropTypes = PropTypes.arrayOf(testSessionNotePropType);

export const fetchMorePropTypes = PropTypes.func;

export const hasMorePropTypes = PropTypes.bool;
